import React from "react"
import { useTranslation } from "react-i18next"
import { useLocation } from "react-router-dom"

export const NotFound: React.FC = () => {
  const { t } = useTranslation()
  const location = useLocation()

  return (
    <div id="router-error" className="flex-1 text-center">
      <h2 className="mx-auto my-5 text-3xl font-semibold text-gray-500">{t("errors.error_500_header")}</h2>
      <div className="mx-auto my-5 h-2 w-[60px] bg-error-light" />
      <p className="mx-auto my-7 text-lg font-medium text-gray-600">
        No route for <code>{location?.pathname}</code>
      </p>
    </div>
  )
}

export default NotFound
